// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "orderCard__header-2v9EO";
var _3 = "orderCard__item-1iBv8";
var _4 = "orderCard__buttons-22Chi";
var _5 = "orderCard__passengers-3mXNv";
var _6 = "orderPreview__city-30a_u";
var _7 = "orderPreview__mainCity-1FSol";
var _8 = "orderPreview__period-1FTVf";
var _9 = "orderBooking__root-vtVji";
var _a = "orderBooking__typeAccount-3RQyJ";
export { _1 as "__esModule", _2 as "orderCard__header", _3 as "orderCard__item", _4 as "orderCard__buttons", _5 as "orderCard__passengers", _6 as "orderPreview__city", _7 as "orderPreview__mainCity", _8 as "orderPreview__period", _9 as "orderBooking__root", _a as "orderBooking__typeAccount" }
export default { "__esModule": _1, "orderCard__header": _2, "orderCard__item": _3, "orderCard__buttons": _4, "orderCard__passengers": _5, "orderPreview__city": _6, "orderPreview__mainCity": _7, "orderPreview__period": _8, "orderBooking__root": _9, "orderBooking__typeAccount": _a }
